import template from './topdata-reg-attempt-log-detail.html.twig';
import './topdata-reg-attempt-log-detail.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;
const { date } = Shopware.Utils.format;

Shopware.Component.register('topdata-reg-attempt-log-detail', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            item: null,
            isLoading: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_registration_attempt_log');
        },

        logId() {
            return this.$route.params.id;
        },
    },

    created() {
        this.loadEntity();
    },

    methods: {
        loadEntity() {
            this.isLoading = true;

            const criteria = new Criteria();
            criteria.addAssociation('customer');

            this.repository.get(this.logId, Shopware.Context.api, criteria).then((result) => {
                this.item = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        getConflictTypeVariant(conflictType) {
            const variants = {
                customer_exists: 'danger',
                contact_exists: 'warning',
            };
            return variants[conflictType] || 'info';
        },

        getAttemptTypeLabel(attemptType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.attemptType.${attemptType}`, 0, attemptType);
        },

        getConflictTypeLabel(conflictType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.conflictType.${conflictType}`, 0, conflictType);
        },

        formatDate(value) {
            if (!value) {
                return '';
            }
            return date(value, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
    },
});
